export default __webpack_public_path__ + "static/panaro-9b471d3a4c6c136e485fecc6c7e662ab.jpg";